import axios, { AxiosResponse } from 'axios';
import { http } from "@/plugins/axios";

const endPoint = '/OpenPolls';

// Типы данных для состояния
export interface IPoll {
  Code: number;
  Title: string;
  IsReaded: boolean;
  // Добавь остальные поля из API при необходимости
}

export interface IPollResult {
  QuestionId: number;
  Answer: string;
  // Добавь остальные поля при необходимости
}

export interface IPollState {
  poll: IPoll | null;
  pollResults: IPollResult[] | null;
}

/**
 * Получение информацию о голосовании
 *
 * @param   {string}  Code  Код доступа
 *
 * @return  {Object}         Информацию о голосовании
 */
const getInfo = (Code: string): Promise<AxiosResponse<IPoll>> => {
  return axios.post(`${endPoint}/GetInfo`, {Code});
}

/**
 * Сохранение результата опроса
 *
 * @param   {Object}  PollingResult
 * @param   {string}  PollingResult.Code       Код доступа
 * @param   {string}  PollingResult.ExtraInfo  Дополнительная информация
 * @param   {Array}  PollingResult.Answers     Ответы на вопросы
 *
 * @return  {Object}                           Статус сохранения результата опроса
 */
const saveResult = (payload: object): Promise<AxiosResponse<IPoll>> => {
  return http.post(`${endPoint}/SaveResult`, payload);
}

/**
 * Обновление информации о прочтении
 *
 * @param   {string}  Code  Код доступа
 *
 * @return  {Object}        Статус обновления информации о прочтении
 */
const setReadedFlag = (Code: string): Promise<AxiosResponse<IPoll>> => {
  return http.post(`${endPoint}/SetReadedFlag`, { Code });
}

/**
 * Получение результата опроса
 *
 * @param   {string}  Code  Код доступа
 *
 * @return  {Object}        Результата опроса
 */
const results = (Code: string): Promise<AxiosResponse<IPollResult[]>> => {
  return http.post(`${endPoint}/Results`, { Code });
}

export default {
  getInfo,
  saveResult,
  setReadedFlag,
  results
}